import PropTypes from 'prop-types';

export const DEFAULT_ROWS = 4;

const TextInput = ({
  id, className, multiline, rows, label, maxLength, value, placeholder, onChange, readOnly = false
}) => {
  const editorProps = {
    id: id ?? 'text',
    'data-rbf': id ?? 'text',
    'data-test-id': id ?? 'text',
    type: 'text',
    className: `form-control${className ? ' ' + className : ''}`,
    maxLength,
    value,
    readOnly,
    placeholder,
    onChange: (e) => onChange(e.target.value)
  };

  return (
    <div className="form-group text-input" data-test-id="text-input">
      {label && (
        <div className="text-input-label">
          <label data-test-id="text-input-label" htmlFor={editorProps.id}>
            {label}
          </label>
        </div>
      )}
      {multiline ? (
        <textarea {...editorProps} rows={rows || DEFAULT_ROWS} />
      ) : (
        <input {...editorProps} name={id} />
      )}
    </div>
  );
};

TextInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};

export default TextInput;
